import React from 'react';
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import moment from 'moment';
import {fetchSubscriptions} from '../../actions/SubscriptionActions';
import {getInvoiceList} from "../../actions/InvoiceActions";
import {intlShape} from 'react-intl';
import MonAbonnementBpiLogo from '../../svgComponents/MonAbonnementBpiLogo.jsx';
@connect ((store) =>{
	return {
		subscriptions: store.subscription.subscriptionsList,
		invoices: store.invoice.invoices,
		messages: store.messages.messages,
	}
})
export default class MyInvoices extends React.Component {
	static propTypes = {
		intl: intlShape
	}
	constructor() {
		super();
	};

	componentDidMount() {
		this.props.dispatch(fetchSubscriptions());
		this.props.dispatch(getInvoiceList());
	}


	render() {
		const { subscriptions, messages } = this.props;
		return (
			<div id="mesInvoices" className="col-md-12">
				<div className="col-md-8">
					<div className="stat-panel col-md-12">
						<p className="title stat-panel">{messages["common.label.my.invoices"]}</p>
					</div>
				</div>
				<div id="myInvoices-page">
					{!!subscriptions && subscriptions.map((subscription) => {
						const { offerTemplate } = subscription || {};
						const { offerTemplateCategory } = offerTemplate || {};
						const offerTemplateCategoryCode = offerTemplateCategory.find(offerTemplateCategory => (offerTemplateCategory.code === "ADH") || (offerTemplateCategory.code === "PMU"));
						let offerCategory = "";
						if (!!offerTemplateCategoryCode) {
							offerCategory = offerTemplateCategoryCode.description;
						}
						const status = (subscription.status === "RESILIATED" || subscription.status === "TERMINATED") ? true : false;
						return (
							<li key={subscription.code.toString()}>
								<div className="stat-panel col-md-6 paddingLeftClass padding-top">
									<p className="stat-panel sousTitle">{offerCategory}</p>
									<div className="text-center box-amount-small">
										<div className="yellow-color text-left">
											<p> <strong>{subscription.offerTemplate.name}</strong></p>
										</div>
										<div className="text-left col-md-8">
											<p className="amount">{subscription.offerTemplate.description}</p>
											{subscription.status === "ACTIVE" && (
												<p className='amount'>
													<span className='card-subtitle'>
														{messages['common.label.since.active']}
														{': '}
													</span>
													<span className='card-content'>
														{moment(subscription.subscriptionDate).format('DD/MM/YYYY')}
													</span>
												</p>
											)}
											{status && (
												<p className='amount'>
													<span className='card-subtitle'>
														{messages['common.label.since.terminate']}
														{': '}
													</span>
													<span className='card-content'>
														{moment(subscription.terminationDate).format('DD/MM/YYYY')}
													</span>
												</p>
											)
											}
										</div>
										<div className="text-right col-md-4" >
											<MonAbonnementBpiLogo />
										</div>
										<div className="box-body" style={{ position: "absolute", bottom: "5px" }}>
											<Link to={myInvoicesDetails_url.path + "/" + subscription.code}>
												<button className="btn btn-theme-default">{messages["common.link.access.my.bills"]}</button>
											</Link>
										</div>
									</div>
								</div>
							</li>
						)
					})}
				</div>
			</div>
		)

	}
}



// WEBPACK FOOTER //
// ./src/opencell/pages/client/MyInvoices.jsx